import { formatBirthday } from "../../../ana-toolbox/ana-toolbox.js";
import { differenceInYears } from "date-fns";
import "../../../../../constants/date/date.js";
import "../../../../../type/Appointment.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
const getAgeFromBirthday = (birthday) => {
  if (!birthday)
    return 0;
  try {
    const birthdayDate = new Date(formatBirthday(birthday));
    return differenceInYears(/* @__PURE__ */ new Date(), birthdayDate);
  } catch {
    return 0;
  }
};
export {
  getAgeFromBirthday as default
};
